// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__ojplA","left":"ModalHeader_left__oHkcX","title":"ModalHeader_title__29pKO","sub":"ModalHeader_sub__Yr6q5"};